module.exports = __webpack_public_path__ + "static/media/ruth.5d1b0449.png";